import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toHandlers as _toHandlers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://via.placeholder.com/40",
  alt: "Profile Image"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
            key: 0,
            app: "",
            class: "navbar-drawer-dark",
            dark: "",
            modelValue: _ctx.drawer,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: _ctx.globalSettings.siteLogo,
                "max-height": "128",
                "min-height": "128",
                contain: ""
              }, null, 8, ["src"]),
              _createVNode(_component_v_list, {
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-view-dashboard",
                    title: "Home",
                    value: "home",
                    to: "/home"
                  }),
                  (_ctx.hasAdminPermission())
                    ? (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 0,
                        value: "Admin",
                        "prepend-icon": "mdi-security"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, {
                            "prepend-icon": "mdi-security",
                            title: "Admin"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          (_ctx.hasPermission('ADMIN_VIEW_USERS'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                title: "Benutzer",
                                value: "user",
                                to: "/admin/users"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasPermission('ADMIN_VIEW_ROLES'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                title: "Rollen",
                                value: "roles",
                                to: "/admin/roles"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasPermission('ADMIN_VIEW_EMPLOYEE'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                title: "Mitarbeiter",
                                value: "employees",
                                to: "/admin/employees"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasPermission('ADMIN_VIEW_APPLICATION'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 3,
                                title: "Bewerberfragen",
                                value: "applicationquestions",
                                to: "/admin/applicationquestions"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasPermission('ADMIN_VIEW_MAP'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 4,
                                title: "Karte",
                                value: "adminmap",
                                to: "/admin/map"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.hasPermission('ADMIN_VIEW_SETTINGS'))
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 5,
                                title: "Settings",
                                value: "settings",
                                to: "/admin/settings"
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_divider)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_EMPLOYEE'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        "prepend-icon": "mdi-fire-truck",
                        title:  _ctx.globalSettings.employeeNavigation || 'Mitarbeiter',
                        value: "employee",
                        to: "/employee"
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_DOCUMENT'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        "prepend-icon": "mdi-file-document-outline",
                        title: "Documents",
                        value: "document",
                        to: "/document"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_TODO'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 3,
                        "prepend-icon": "mdi-format-list-checks",
                        title: "To-Do",
                        value: "todo",
                        to: "/todo"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_CALENDAR'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 4,
                        "prepend-icon": "mdi-calendar-clock",
                        title: "Calendar",
                        value: "calendar",
                        to: "/calendar"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_APPLICATION'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 5,
                        "prepend-icon": "mdi-human-edit",
                        title: "Applications",
                        value: "application",
                        to: "/application"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_TEMPLATE'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 6,
                        "prepend-icon": "mdi-file-edit-outline",
                        title: "Templates",
                        value: "template",
                        to: "/template"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_DOCUMENT_TRAINING'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 7,
                        "prepend-icon": "mdi-book-open",
                        title: "Trainings",
                        value: "trainings",
                        to: "/training"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasPermission('VIEW_MAP'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 8,
                        "prepend-icon": "mdi-map",
                        title: "Karte",
                        value: "map",
                        to: "/map"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_v_app_bar, {
            key: 1,
            app: "",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_app_bar_nav_icon, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawer = !_ctx.drawer))
              }),
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.globalSettings.siteName || 'Kyuubi D. Dragon Administration Tool'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_avatar, null, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_menu, { "offset-y": "" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({ text: "" }, props, _toHandlers(props.listeners)), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile.username), 1)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { onClick: _ctx.goToProfile }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Profil anzeigen")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, { onClick: _ctx.editProfile }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Profil bearbeiten")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_v_list_item, { onClick: _ctx.logout }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Ausloggen")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, { id: "web-body" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}